import { format as formatFn } from "date-fns";

import { useDateLocale } from "hooks/useDateLocale";

interface LocaleDateFormatter {
  formatDate: (date: string | Date, format?: string) => string;
}

export const useLocaleDateFormatter = (): LocaleDateFormatter => {
  const dateLocale = useDateLocale();

  const formatDate = (date: string | Date, format = "MMMM d, yyyy") => {
    return formatFn(new Date(date), format, { locale: dateLocale });
  };

  return {
    formatDate,
  };
};
